(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["herb-heaven"] && !Shopify.designMode) return;
  try {
    
(function(){
  if(window.HerbHeavenMotion){window.HerbHeavenMotion.scan();return;}
  var preference=window.matchMedia('(prefers-reduced-motion: reduce)');
  var mounted=new Map();
  function clean(root){
    var observer=mounted.get(root);
    if(observer)observer.disconnect();
    root.classList.remove('hh-motion-ready');
    root.querySelectorAll('.hh-reveal').forEach(function(el){el.classList.remove('hh-reveal','hh-reveal-pending');el.style.removeProperty('--hh-reveal-delay');});
    mounted.delete(root);
  }
  function reveal(el){
    el.classList.remove('hh-reveal-pending');
    window.setTimeout(function(){el.classList.remove('hh-reveal');el.style.removeProperty('--hh-reveal-delay');},1100);
  }
  function scan(){
    mounted.forEach(function(observer,root){if(!root.isConnected)clean(root);});
    document.querySelectorAll('.hh').forEach(function(root){
      if(mounted.has(root)||preference.matches)return;
      root.classList.add('hh-motion-ready');
      if(!('IntersectionObserver' in window)){mounted.set(root,null);return;}
      var observer=new IntersectionObserver(function(entries){
        entries.forEach(function(entry){if(entry.isIntersecting){reveal(entry.target);observer.unobserve(entry.target);}});
      },{threshold:0,rootMargin:'0px 0px -36px 0px'});
      mounted.set(root,observer);
      root.querySelectorAll('.hh-ribbon,.hh-section-head,.hh-card,.hh-news-teaser,.hh-gallery figure,.hh-story-grid > div,.hh-contact-grid > div,.hh-foot-top').forEach(function(el){
        if(el.getBoundingClientRect().top<window.innerHeight-36)return;
        var siblingIndex=Array.prototype.indexOf.call(el.parentElement.children,el);
        el.style.setProperty('--hh-reveal-delay',Math.min(siblingIndex,3)*65+'ms');
        el.classList.add('hh-reveal','hh-reveal-pending');observer.observe(el);
      });
    });
  }
  window.HerbHeavenMotion={scan:scan};
  document.addEventListener('shopify:section:load',scan);
  document.addEventListener('shopify:section:unload',function(event){mounted.forEach(function(observer,root){if(event.target.contains(root))clean(root);});});
  document.addEventListener('shopify:block:select',function(event){var target=event.target;if(target.classList.contains('hh-reveal-pending'))reveal(target);target.querySelectorAll('.hh-reveal-pending').forEach(reveal);});
  function preferenceChanged(){mounted.forEach(function(observer,root){clean(root);});scan();}
  if(preference.addEventListener)preference.addEventListener('change',preferenceChanged);
  else if(preference.addListener)preference.addListener(preferenceChanged);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan,{once:true});else scan();
})();

(function(){
  function setup(){
    document.querySelectorAll('.hh').forEach(function(root){
      if(root.dataset.hhInteractive)return;
      root.dataset.hhInteractive='true';
      var tabs=Array.from(root.querySelectorAll('.hh-tab'));
      function choose(tab,focus){
        tabs.forEach(function(item){
          var selected=item===tab;
          item.setAttribute('aria-selected',String(selected));
          item.tabIndex=selected?0:-1;
          var panel=document.getElementById(item.getAttribute('aria-controls'));
          if(panel)panel.hidden=!selected;
        });
        if(focus)tab.focus();
      }
      tabs.forEach(function(tab,index){
        tab.addEventListener('click',function(){choose(tab,false);});
        tab.addEventListener('keydown',function(event){
          var next=index;
          if(event.key==='ArrowRight')next=(index+1)%tabs.length;
          else if(event.key==='ArrowLeft')next=(index-1+tabs.length)%tabs.length;
          else if(event.key==='Home')next=0;
          else if(event.key==='End')next=tabs.length-1;
          else return;
          event.preventDefault();choose(tabs[next],true);
        });
      });
      if(tabs.length)choose(tabs[0],false);
      root.classList.add('hh-interactive-ready');
      var motion=root.querySelector('[data-hh-motion]');
      if(motion){motion.hidden=false;motion.addEventListener('click',function(){
        var paused=root.classList.toggle('hh-paused');
        motion.setAttribute('aria-pressed',String(paused));
        motion.textContent=paused?'Resume motion':'Pause motion';
      });}
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup,{once:true});else setup();
  document.addEventListener('shopify:section:load',setup);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
